import React, { useRef, useState } from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';

/** Shared Discover/brand viewer. Callers own data mapping and any actions. */
export function AdMediaDialog({ title, imageUrl, videoUrl, onClose, children, footer, previewTestId }: {
  title: string;
  imageUrl?: string | null;
  videoUrl?: string | null;
  onClose: () => void;
  children: React.ReactNode;
  footer?: React.ReactNode;
  previewTestId?: string;
}) {
  const [videoFailed, setVideoFailed] = useState(false);
  const [imageFailed, setImageFailed] = useState(false);
  const opener = useRef(typeof document === 'undefined' ? null : document.activeElement as HTMLElement | null);
  return (
    <Dialog.Root open onOpenChange={(open) => { if (!open) onClose(); }}>
      <Dialog.Portal>
        <Dialog.Overlay style={{ position: 'fixed', inset: 0, zIndex: 300, background: 'rgba(0,0,0,0.45)' }} />
        <Dialog.Content onCloseAutoFocus={(event) => { event.preventDefault(); opener.current?.focus(); }} aria-describedby={undefined} style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 301, background: '#FAFAF8', border: '1px solid #E5E2DC', borderRadius: 16, width: '90vw', maxWidth: 780, maxHeight: '90vh', display: 'flex', flexDirection: 'column', overflow: 'hidden', boxShadow: '0 24px 60px rgba(0,0,0,0.18)' }}>
          <header style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16, padding: '14px 20px', borderBottom: '1px solid #E5E2DC' }}>
            <Dialog.Title style={{ fontSize: 15, fontWeight: 600, color: '#1A1A1A', margin: 0 }}>{title}</Dialog.Title>
            <Dialog.Close aria-label="Close ad details" style={{ width: 28, height: 28, flexShrink: 0, borderRadius: 8, background: 'transparent', color: '#8C8578', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><X style={{ width: 15, height: 15 }} /></Dialog.Close>
          </header>
          <div style={{ overflowY: 'auto', minHeight: 0 }}>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              <div style={{ flex: '1 1 360px', minWidth: 0, background: '#F0F0EF', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
                {videoUrl && !videoFailed ? (
                  <video src={videoUrl} poster={imageUrl || undefined} controls playsInline preload="metadata" onError={() => setVideoFailed(true)} style={{ maxWidth: '100%', maxHeight: '55vh', objectFit: 'contain', borderRadius: 10 }} />
                ) : imageUrl && !imageFailed ? (
                  <img src={imageUrl} alt={title} onError={() => setImageFailed(true)} style={{ maxWidth: '100%', maxHeight: '55vh', width: 'auto', height: 'auto', objectFit: 'contain', borderRadius: 10, boxShadow: '0 4px 20px rgba(0,0,0,0.10)' }} data-testid={previewTestId} />
                ) : <p style={{ color: '#6B6760', padding: 24 }}>Preview unavailable</p>}
              </div>
              <div style={{ flex: '1 1 220px', minWidth: 0, borderLeft: '1px solid #E5E2DC', padding: '20px 18px', display: 'flex', flexDirection: 'column', gap: 14, overflowWrap: 'anywhere' }}>{children}</div>
            </div>
            {footer && <div style={{ padding: '14px 20px', borderTop: '1px solid #E5E2DC', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>{footer}</div>}
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
